import React, { Component } from "react";
import Form from "react-bootstrap/Form";
import { I18n, Translate } from "react-redux-i18n";
import { connect } from "react-redux";
import { setAlert } from "../../../../actions/alertActions";
import { validateEmail } from "../../../utils/Utils";
import InfoModal from "../../../utils/components/InfoModal";
import arrow_icon from "../../../../styles/images/arrow-breadcrumb.svg";
import info from "../../../../styles/images/info.svg";
import eye from "../../../../styles/images/eye.svg";

export class FormUserDetails extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      name: "",
      email: "",
      password: "",
      checked: false,
      passwordShown: false,
      info: false,
    };
  }

  componentDidMount() {
    if (this.props.isEditing) {
      const { userInfo } = this.props;
      this.setState({
        name: userInfo.name,
        email: userInfo.email,
        password: userInfo.password,
      });
    }
  }

  handleChange = (input) => (e) => {
    this.setState({ [input]: e.target.value });
  };

  validatePassword() {
    const regex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@_$!%*?&])[A-Za-z\d@_$!%*?&]{8,}$/;
    return regex.test(this.state.password);
  }

  continue = (e) => {
    e.preventDefault();

    const guestUser = {
      name: this.state.name,
      email: this.state.email,
      password: this.state.password,
    };

    if (
      this.state.name === "" ||
      this.state.email === "" ||
      this.state.password === ""
    ) {
      this.props.setAlert(
        I18n.t("accessManagement_warningMessageForm"),
        "danger"
      );
      return;
    }

    if (!validateEmail(this.state.email)) {
      this.props.setAlert(I18n.t("signUp_InvalidEmail", "danger"));
      return;
    }

    if (!this.validatePassword()) {
      if (this.props.isEditing) {
        if (this.state.checked) {
          this.props.setAlert(
            I18n.t("accessManagement_invalidPassword", "danger")
          );
          return;
        }
      } else {
        this.props.setAlert(
          I18n.t("accessManagement_invalidPassword", "danger")
        );
        return;
      }
    }

    this.props.handleChange(guestUser);
    this.props.nextStep();
  };

  handleChangeChecked = () => {
    this.setState({ checked: !this.state.checked });
  };

  togglePassword = () => {
    this.setState({
      passwordShown: !this.state.passwordShown,
    });
  };

  render() {
    return (
      <div
        id="access-management-add"
        className="main-component main-container access-management-add"
      >
        <div className="component-container">
          <div className="row">
            <div className="col-sm-12 d-flex">
              <h6 className="disable-text">
                <Translate value="accessManagement_title" />

                <img src={arrow_icon} alt="Icon arrow" />
              </h6>
              <h6 className="d-flex align-items-center">
                <Translate value="drivers_addUser" />
              </h6>
            </div>
          </div>
          <form id="add-guest-users-form">
            <div className="form-info">
              <div className="form-field">
                <label>
                  <Translate value="editAccount_title_name" />
                  <b>*</b>
                </label>
                <input
                  type="text"
                  name="name"
                  value={this.state.name}
                  onChange={this.handleChange("name")}
                />
              </div>
            </div>
            <div className="form-info">
              <div className="form-field form-email">
                <label>
                  <Translate value="editAccount_title_email" />
                  <b>*</b>
                </label>
                <input
                  type="text"
                  name="email"
                  value={this.state.email}
                  onChange={this.handleChange("email")}
                />
              </div>
              <div className="form-field password-guest">
                <label>
                  <b>
                    <Translate value="login_password" />*
                  </b>
                  <button
                    type="button"
                    className="clear"
                    onClick={() => this.setState({ info: true })}
                  >
                    <img src={info} alt="" />
                  </button>
                </label>
                <input
                  type={this.state.passwordShown ? "text" : "password"}
                  name="password"
                  value={this.state.password}
                  onChange={this.handleChange("password")}
                  disabled={this.props.isEditing && !this.state.checked}
                />
                <button
                  type="button"
                  className="eye-password-guest"
                  onClick={() => this.togglePassword()}
                >
                  <img src={eye} alt="" />
                </button>
                {this.props.isEditing && (
                  <div className="change-password-check">
                    <input
                      type="checkbox"
                      value={this.state.checked}
                      onChange={this.handleChangeChecked}
                    />
                    <span>
                      <Translate value="accessManagement_passwordChecked" />
                    </span>
                  </div>
                )}
              </div>
            </div>
          </form>
          <div className="guest-user-next">
            <button
              type="button"
              className="button-prev-next"
              form="add-guest-users-form"
              onClick={this.continue}
            >
              {I18n.t("pageArrowButton_right")}
            </button>
          </div>
          <div className="dots-section">
            <span className="dot-progress dot-background"></span>
            <span className="dot-progress"></span>
          </div>
        </div>
        <InfoModal
          show={this.state.info}
          onHide={() => this.setState({ info: false })}
        >
          <div id="chargerInfoModal">
            <Translate value="signUpTermAndCond_detailsPassword" />
          </div>
        </InfoModal>
      </div>
    );
  }
}

export default connect(null, { setAlert })(FormUserDetails);
